var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 86 55",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M80.01 0 86 6.589 32.825 54.013l-.897.987L0 26.524l5.99-6.589 25.833 23.041L80.011 0z",
  fill: "currentColor",
  fillRule: "evenodd"
})));
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NiA1NSI+CiAgPHBhdGggZD0iTTgwLjAxIDBMODYgNi41ODkgMzIuODI1IDU0LjAxM2wtLjg5Ny45ODdMMCAyNi41MjRsNS45OS02LjU4OSAyNS44MzMgMjMuMDQxTDgwLjAxMSAweiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";